import { expressionDefinitionApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const APPRAISAL_SURCHARGE_SCHEMA_ACTION_TYPE = createNamedActions(
  'appraisalSurchargeSchema',
  {
    GET_APPRAISAL_SURCHARGE_SCHEMA: 'GET_APPRAISAL_SURCHARGE_SCHEMA',
  },
);

export const getAppraisalSurchargeSchemaParamsAction = catchAsyncActionError(
  () => async dispatch => {
    const { data } = await expressionDefinitionApi.getAppraisalSurchargeExpressionDefinition();

    return dispatch({
      type: APPRAISAL_SURCHARGE_SCHEMA_ACTION_TYPE.GET_APPRAISAL_SURCHARGE_SCHEMA,
      payload: data,
    });
  },
);
